import React, { Component } from 'react';
import { Cell } from 'react-flexr';

class SearchGroup extends Component {
  render() {
    const { title, disabled, children, ...props } = this.props;
    const style = {
      padding: '15px 15px 5px' /*,
      borderTop: '1px solid #dddddd'*/
    };

    if (disabled) {
      style.opacity = 0.5;
    }

    return (
      <Cell
        size="1/1"
        lap="1/3"
        style={{ borderTop: '1px solid #dddddd' }}
        {...props}
      >
        <div style={style}>
          {title ? <h5 className="list-group-item-heading">{title}</h5> : null}
          {children}
        </div>
      </Cell>
    );
  }
}

export default SearchGroup;
